jQuery(function ($) {
  var threePanelCollage;
  $.ThreePanelCollage = function () {
  };

  $.ThreePanelCollage.prototype = {

    /**
     * Defines the selection of all sliders on the current view
     * @static
     */
    panelSlider: $('.three-panel-collage'),

    /**
     * @method init
     * @desc initialize this module depending on the client window width. Devices lower than
     * equal 992 trigger initializing slider mode.
     *        Other devices get 3 tile view.
     */
    init: function () {
      if (this.panelSlider && this.panelSlider.length > 0) {
        if ($(window).width() > 992) {
          this.playOnHover();
        }
      }
    },

    /**
     * @method playOnHover
     * @desc sets event listener for mouseenter and leave and plays or stops the video
     */
    playOnHover: function () {
      this.panelSlider.find('.panel-item').on('mouseenter mouseleave', function (e) {
        var video = $(this).find('video').get(0);
        if (typeof video !== 'undefined') {
          video.muted = true;
          if (e.type === 'mouseenter') {
            video.play();
          } else {
            video.pause();
          }
        }
      });
    }
  };

  threePanelCollage = new $.ThreePanelCollage();
  threePanelCollage.init();
});
